var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"mb-32"},[_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('b-row',{attrs:{"align-v":"center","align-h":"between"}},[_c('div',[_c('h3',[_vm._v("Welcome back, Agent 👋")]),_c('p',{staticClass:"hp-p1-body mb-0"},[_vm._v(" Your current status and analytics are here ")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }